import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export default function StepSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className='w-full max-w-[320px] space-y-8 text-center'>
      <div className='space-y-2'>
        <h1 className='text-3xl font-semibold text-ws-text'>
          {t('auth.signup.success.message')}
        </h1>
        <p className='text-base text-ws-muted'>
          {t('auth.signup.success.subtitle')}
        </p>
      </div>
      <Button variant='primary' size='lg' block onClick={() => navigate('/app')}>
        {t('auth.signup.success.cta')}
      </Button>
    </div>
  );
}
